export class Master{
    public Id : Number;
    public Code : String;
    public AppConfigId : Number;
    public ParentId : Number;
    public Name : String;
    public Description : String;
    public LanguageId : Number;
    public Sequence : Number;
    public Status : Number;
    
}

export class Order{
    public Month : String = "";
    public LastYear : String = "";
    public CurrentYear : String = "";
}

export class OrderData{
    public Year: Number = 0;
    public Jan: Number = 0;
    public Feb: Number = 0;
    public Mar: Number = 0;
    public Apr: Number = 0;
    public May: Number = 0;
    public Jun: Number = 0;
    public Jul: Number = 0;
    public Aug: Number = 0;
    public Sep: Number = 0;
    public Oct: Number = 0;
    public Nov: Number = 0;
    public Dec: Number = 0;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/dashboard.model.ts